export const spotOrigin = typeof window === 'undefined' ? 'https://www.ttx.vip' : window.location.origin
export const SITE_NAME = 'tt'
export function getDomain(): string {
  if (import.meta.env.DEV) {
    return 'ttx.one'
  }
  return import.meta.client ? location.host.split('.').slice(-2).join('.') : 'ttx.vip'
}
